import { CoopThemeContext } from '@cpbtechnology/coop-shared/ui/themes/shared/context'
import { useContext } from 'react'

export const useTheme = () => useContext(CoopThemeContext)
